// extracted by mini-css-extract-plugin
export default {"productGallery":"mI-z","inQuickShop":"nI-z"};